import React from 'react';
import { AbstractMapView } from 'app/components/dashboard/network/AbstractMapView';

export class SharedMapView extends AbstractMapView {}
